import { MINUTE_IN_MILLISECONDS } from "shared/constants";
import Poller from "shared/services/polling/Poller";
import { useMentionCountsStore } from "shared/stores/mentionCounts";

function callback() {
  useMentionCountsStore().fetchMentionCounts();
}

export default new Poller({ interval: MINUTE_IN_MILLISECONDS, callback });
